export interface DiffLine {
    type: 'same' | 'add' | 'remove';
    text: string;
}

/** Line-based diff (longest common subsequence) from `before` to `after`. */
export function diffLines(before: string, after: string): DiffLine[] {
    const a = before.split('\n');
    const b = after.split('\n');
    const lcs: number[][] = Array.from({ length: a.length + 1 }, () =>
        new Array<number>(b.length + 1).fill(0)
    );
    for (let i = a.length - 1; i >= 0; i--) {
        for (let j = b.length - 1; j >= 0; j--) {
            lcs[i][j] =
                a[i] === b[j]
                    ? lcs[i + 1][j + 1] + 1
                    : Math.max(lcs[i + 1][j], lcs[i][j + 1]);
        }
    }
    const result: DiffLine[] = [];
    let i = 0;
    let j = 0;
    while (i < a.length && j < b.length) {
        if (a[i] === b[j]) {
            result.push({ type: 'same', text: a[i] });
            i++;
            j++;
        } else if (lcs[i + 1][j] >= lcs[i][j + 1]) {
            result.push({ type: 'remove', text: a[i++] });
        } else {
            result.push({ type: 'add', text: b[j++] });
        }
    }
    while (i < a.length) result.push({ type: 'remove', text: a[i++] });
    while (j < b.length) result.push({ type: 'add', text: b[j++] });
    return result;
}
